import PropTypes from 'prop-types';
import React from 'react';
import { Formik } from 'formik';
import { RepliconDialog } from '~/modules/common/components';
import SetResourceAllocationDialogTitle from './SetResourceAllocationDialogTitle';
import SetResourceAllocationDialogContent from './SetResourceAllocationDialogContent';
import SetResourceAllocationDialogFooter from './SetResourceAllocationDialogFooter';

const SetResourceAllocationDialogTitleId =
  'set-resource-allocation-dialog-title';

const SetResourceAllocationDialog = ({ onClose, open, project, user }) => {
  return (
    <RepliconDialog
      aria-labelledby={SetResourceAllocationDialogTitleId}
      data-qe-id="SetResourceAllocationDialog"
      enableUnsavedChangesWarning
      open={open}
      onClose={onClose}
      trapFocusWithDatePicker
    >
      <SetResourceAllocationDialogTitle
        project={project}
        titleId={SetResourceAllocationDialogTitleId}
        user={user}
      />
      <Formik
        initialValues={{}} // TODO
        onSubmit={() => {}} // TODO
      >
        <>
          <SetResourceAllocationDialogContent />
          <SetResourceAllocationDialogFooter onClose={onClose} />
        </>
      </Formik>
    </RepliconDialog>
  );
};

SetResourceAllocationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  project: PropTypes.object,
  user: PropTypes.object
};

export default SetResourceAllocationDialog;
